/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index term-definition to autogenerate all the components and extensions
 * Used by "prepareTermDefinitions"
 */

import TermDefinition from './term-definition/TermDefinition'
export * from './term-definition/TermDefinition'
export default TermDefinition
